export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 50;
export const MAX_EMAIL_LENGTH = 129;
export const MAX_NAME_LENGTH = 50;
export const MIN_NAME_LENGTH = 2;
export const PHONE_LENGTH = 12;